import { MediaImagesIcon } from '@nexus/ari-lib/assets/icons';
import { imageOutlineSx } from '@nexus/ari-lib/theme/surfaces';
import { RecentFilesCard } from '@nexus/ari-lib/sections/file-library';

import { Box, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export type MediaItem = {
  id: number;
  src: string;
  duration?: string;
};

type DashboardMediaSectionProps = {
  items: MediaItem[];
  onClick?: () => void;
  comingSoon?: boolean;
};

export function DashboardMediaSection({ items, onClick, comingSoon = false }: DashboardMediaSectionProps) {
  return (
    <RecentFilesCard
      testId="cloud.dashboard.media-section"
      title="Media"
      subtitle="Photos and Videos"
      icon={<MediaImagesIcon sx={{ width: 28, height: 28 }} />}
      onClick={onClick}
      comingSoon={comingSoon}
      items={items}
      emptyIcon={<MediaImagesIcon sx={{ width: 40, height: 40, opacity: 0.4 }} />}
      emptyLabel="No media captured yet"
      columns={4}
      gap={0.5}
      renderItem={(item) => (
        <Box
          sx={{
            width: '100%',
            paddingTop: '100%',
            bgcolor: 'action.disabledBackground',
            borderRadius: 1,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            src={item.src}
            alt="media"
            loading="lazy"
            width={120}
            height={120}
            sx={(theme) => ({
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              ...imageOutlineSx(theme),
            })}
          />
          {item.duration && (
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                bottom: 3,
                right: 5,
                color: 'common.white',
                fontSize: 10,
                fontWeight: 600,
                textShadow: '0 1px 2px rgba(0,0,0,0.6)',
              }}
            >
              {item.duration}
            </Typography>
          )}
        </Box>
      )}
    />
  );
}
